import * as Preact from 'preact';
import { Box } from '@mui/material';
import { IconButton, Link, Typography } from '@mui/material';
import { FacebookShare, WhatsappShare, Email, LinkIcon } from './icons';
var IconAndText = function (props) {
    return (Preact.h(Box, { display: "flex", flexDirection: "column", alignItems: "center", height: "76px", justifyContent: "space-between" },
        props.icon,
        Preact.h(Typography, { fontSize: "11px", fontWeight: "500", textAlign: "center" }, props.text)));
};
export var Component = function (p) {
    return (Preact.h(Box, { display: "flex", gap: "12px", padding: "24px", justifyContent: "center", alignItems: "center", bgcolor: "background.paper", "data-testid": "share-button-container" },
        Preact.h(IconAndText, { icon: Preact.h(Link, { href: 'http://www.facebook.com/share.php?u=' + encodeURIComponent(p.url), target: "_blank", onClick: function () { return p.onShareButtonClick('facebook'); }, "data-testid": "share-facebook" },
                Preact.h(FacebookShare, { sx: {
                        fontSize: '52px !important',
                        backgroundColor: 'rgba(10, 132, 255, 1)',
                        borderRadius: '50%',
                    } })), text: p.facebookText }),
        Preact.h(IconAndText, { icon: Preact.h(Link, { href: 'https://api.whatsapp.com/send?text=' + encodeURIComponent(p.url), target: "_blank", onClick: function () { return p.onShareButtonClick('whatsapp'); }, "data-testid": "share-whatsapp" },
                Preact.h(WhatsappShare, { sx: {
                        backgroundColor: 'rgba(31, 202, 3, 1)',
                        borderRadius: '50%',
                        fontSize: '52px !important',
                    } })), text: p.whatsappText }),
        Preact.h(IconAndText, { icon: Preact.h(IconButton, { onClick: p.onLinkClick, sx: {
                    width: '52px',
                    height: '52px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(247, 247, 247, 1)',
                    '&.MuiIconButton-root:hover': {
                        backgroundColor: 'rgba(247, 247, 247, 1)',
                    },
                }, "data-testid": "share-copy" },
                Preact.h(LinkIcon, null)), text: p.linkText }),
        Preact.h(IconAndText, { icon: Preact.h(Link, { href: "mailto:?subject=".concat(p.emailSubject, "&body=").concat(p.emailContent, "%0A").concat(encodeURIComponent(p.url)), target: "_blank", sx: {
                    width: '52px',
                    height: '52px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(247, 247, 247, 1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }, onClick: function () { return p.onShareButtonClick('email'); }, "data-testid": "share-email" },
                Preact.h(Email, null)), text: p.emailText })));
};
Component.displayName = 'SharingIcons';
